import { createApp } from 'vue';
import App from './App.vue';
import router from './router/router.js';
import store from './store'; // Импортируем store

// Import Bootstrap CSS and JS
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import '@popperjs/core'; // Обязательно для интерактивных компонентов

createApp(App).use(router).use(store).mount('#app');
